module.exports = __webpack_public_path__ + "img/area-comum-12.cf047465.png";